// invite.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../global/globals';

@Injectable({
  providedIn: 'root'
})
export class InviteService {
  constructor(private httpClient: HttpClient, private globals: Globals) {}

  processInviteLink(email: string, token: string, user:string): Observable<any> {
    const url = `${this.globals.backendUri}/user/departmentInvite/${email}/${token}/${user}`;
    return this.httpClient.put(url, {});
  }
}
